import { Nullable } from 'common/models/optional';
import { Treasury } from 'common/models/treasury';
import React from 'react';
import { InputUtils } from 'utils/inputUtils';
import FormatNumber from '../FormatPercent/FormatNumber';
import FormatTokenName from '../FormatTokenName/FormatTokenName';
import { MintableToken } from 'constants/contracts';

type Props = {
  display: boolean;
  amount: string;
  treasury: Nullable<Treasury>;
  tokenContractContainer: Nullable<MintableToken>;
};

const MintMetadata: React.FC<Props> = (props) => {
  if (!props.display) {
    return null;
  }

  const amountNumber = InputUtils.isTruthy(props.amount)
    ? Number(props.amount)
    : 0;
  const mintingRatio = props.treasury ? props.treasury.mintingRatio : 1;
  const mintingFee = props.treasury ? props.treasury.mintFee : 0;

  // calculate required collateral and member token amounts
  let collateralUSDValue = amountNumber * mintingRatio;
  const memberTokensUSDValue = amountNumber - collateralUSDValue;

  collateralUSDValue += amountNumber * mintingFee;
  // ------------------------ ^^
  return (
    <div className="p-3 m-3 content-inner-bg-color heading-color">
      <div className="flex flex-row justify-between items-center">
        Minting Ratio
        <FormatNumber
          value={mintingRatio ? mintingRatio * 100 : 100}
          displayDecimals={1}
          postfix="%"
          id="minting-ratio"
          className="font-medium primary-text-color cy-number-percent"
        />
      </div>
      <div className="flex flex-row justify-between items-center">
        <FormatTokenName
          token={props.tokenContractContainer?.collateralToken}
        />
        <FormatNumber
          value={collateralUSDValue}
          displayDecimals={3}
          prefix="$"
          defaultDisplay="1.00"
          id="metadata-collateral"
          className="font-medium primary-text-color cy-number-percent"
        />
      </div>
      <div className="flex flex-row justify-between items-center">
        <FormatTokenName token={props.tokenContractContainer?.memberToken} />
        <FormatNumber
          value={memberTokensUSDValue}
          displayDecimals={3}
          prefix="$"
          id="memberToken"
          className="font-medium primary-text-color cy-number-percent"
        />
      </div>
    </div>
  );
};

export default MintMetadata;
